var React = require('react');

function CalendarAlerts (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 10V8L0.149262 7.99451C1.13238 7.92198 1.91786 7.13877 1.99396 6.15665L2 6V4C2 1.79086 3.79086 0 6 0C8.1422 0 9.89108 1.68397 9.9951 3.80036L10 4V6C10 7.05436 10.8159 7.91817 11.8507 7.99451L12 8V10H8C8 11.1046 7.10457 12 6 12C4.94564 12 4.08183 11.1841 4.00549 10.1493L4 10H0Z","fill":"currentColor"}));
}

CalendarAlerts.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarAlerts;

CalendarAlerts.default = CalendarAlerts;
